export default __webpack_public_path__ + "static/media/fabrizioRinaldi.6c1c09da.png";